import useFeatureFlag, { FEATURE_FLAGS } from '@/utils/featureFlags';

const useReceiptsFeatureFlag = () => {
  const isReceiptsEnabled = useFeatureFlag(FEATURE_FLAGS.RECEIPTS_FULL_FLOW);
  return { isReceiptsEnabled };
};

export default useReceiptsFeatureFlag;
